module.exports = __webpack_public_path__ + "img/noavatar.fb765622.png";